import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import TasCommentsContent, { AddCommentForm } from '../../comments/content.gts';
import type TasProgramInstanceModel from 'tio-data/models/tas-program-instance';
import type PersonModel from 'tio-data/models/person';
import type UserModel from 'tio-data/models/user';
import { DrawerHeader, DrawerBody, DrawerFooter } from 'tio-ui/components/drawer';

import type SessionContextService from '../../../../services/session-context.ts';
/**
 * Comments drawer for program instance approvals
 * Wraps TasCommentsContent for program instance comments
 */
interface CommentsDrawerSignature {
  Args: {
    instance: TasProgramInstanceModel;
    initialTab?: 'approver' | 'employee';
    showEmployeeTab?: boolean;
  };
}

export default class ProgramCommentsDrawer extends Component<CommentsDrawerSignature> {
  @service declare sessionContext: SessionContextService;

  @tracked activeTab: 'approver' | 'employee' = this.args.initialTab ?? 'approver';

  get commentTags() {
    return this.activeTab === 'approver' ? ['approver'] : ['Partner Messaging'];
  }

  get authoredByPerson(): PersonModel {
    return this.sessionContext.user?.person;
  }

  get authoredByUser(): UserModel {
    return this.sessionContext.user;
  }

  handleTabChange = (tab: 'approver' | 'employee') => {
    this.activeTab = tab;
  };

  <template>
    <div class="tio-col-flush h-full">
      <DrawerHeader>
        <h2 class="tio-text-heading tio-fg-primary">{{t
            "tuition_assistance.application_approval.comments"
          }}</h2>
      </DrawerHeader>
      <DrawerBody>
        <TasCommentsContent
          @commentable={{@instance}}
          @commentableType="TasProgramInstance"
          @authoredByPerson={{this.authoredByPerson}}
          @authoredByUser={{this.authoredByUser}}
          @commentTags={{array "approver"}}
          @hideAddCommentForm={{true}}
          @initialTab={{@initialTab}}
          @onTabChange={{this.handleTabChange}}
          @showEmployeeTab={{@showEmployeeTab}}
        />
      </DrawerBody>
      <DrawerFooter>
        <AddCommentForm
          @commentable={{@instance}}
          @commentableType="TasProgramInstance"
          @authoredByPerson={{this.authoredByPerson}}
          @commentTags={{this.commentTags}}
          @inDrawer={{true}}
        />
      </DrawerFooter>
    </div>
  </template>
}
